import styled from 'styled-components';
import Image from '@stencil/image';
import {
  FlexCentered,
  CenteredDivWrap,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const GalleryBlockContainer = styled.div`
  display: flex;
  width: 50%;
`;

export const SmallGalleriesAndLocationPersuasion = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
`;

export const GalleryContainer = styled.div(
  props => `
  display: flex;
  position:relative;
  margin-bottom:${props.theme.spacing.base};
  cursor: pointer;
`,
);

export const LocationInfo = styled.div(
  props => `
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    min-height:10.5rem;
`,
);

export const LocationHeader = styled.p(
  props => `
    font-size:${props.theme.font.custom(14)};
    font-weight:bold;
    margin-left: ${props.theme.spacing.small};
`,
);

export const DistanceList = styled.ul(
  props => `
    padding-left:${props.theme.spacing.large};
    padding:${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(12)} 0 ${
    props.theme.spacing.xxlarge
  };
    width:100%;
    li{
      width:100%
      list-style-type: disc;
    }
`,
);

export const ViewInMap = styled.div(props => {
  let conditionalStyles = '';

  if (!!props.noLocationItems) {
    conditionalStyles = `
        height: ${props.noLocationItems ? '100%' : 'auto'}
        display: flex;
        justify-content: center;
      `;
  }

  return `
      padding: ${props.theme.spacing.custom(8)} ${props.theme.spacing.xxlarge}
      ${conditionalStyles}
    `;
});

export const NoGalleryImageWrap = styled(CenteredDivWrap)(
  props => `
  background-color:${props.theme.colors.goBrandBlue.light};
  width: 59rem;
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const SingleGalleryImage = styled(Image)(
  props => `
    width: 100%;
    height: 100%;
  `,
);

export const LocationInfoItem = styled.li(
  props => `
  background: ${props.background ? props.background : props.theme.colors.goWhite.base};
  color: ${props.color ? props.color : props.theme.colors.downriver.base};
  cursor: pointer;
`,
);

export const LocationInfoTextContainer = styled.div`
  height: 70%;
`;

export const LocationInfoHeaderWrap = styled(FlexCentered)(
  props => `
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding:${props.theme.spacing.base};
`,
);

export const ImageStyle = styled(Image)(
  props => `
  display: flex;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  height: 21rem;
  width: 24.5rem;
`,
);
